import * as actionTypes from './actionTypes';

export const initialCheckoutState = {
  isLoaded: false,
  initalAsyncApiCall: false,
  isSaveCartEmailValid: false,
  isShippingUpdated: false,
  status: false,
  cart: {},
  depletionType: '',
  shipment: {},
  payment: {},
  smsEnabledDevice: {},
  validateOrderDetails: {},
  orderDetails: {},
  lineDetails: {},
  cartHeader: {},
  getCheckoutResponse: {},
  errors: {},
  isManual: '',
  orderDetailsView: {},
  orderNo: '',
  confirmation: {},
  errorInfo: {
    status: false,
    msg: '',
  },
  addRemoveResponse: {},
  removeYtTvResponse: {},
  isValidPromoResponse: {},
  accountOwnerEmailSent: false,
  accountOwnerEmail: '',
  isFormErrors: 'default',
  fwaOfferECRecommendations: {},
  updateProcessCompleted: false,
  isGetCheckoutApiLoaded: false,
  displaySavecartSection: false,
  isEmailSuccess: {},
  emailMaxAttempts: false,
  saveCartSuccessResponse: false,
  prefetchExpressCheckoutStatus: null,
  featureFlags: {},
  showPerkDrawer: false,
  ecSelectedPerksAdd: [],
  ecSelectedPerksRemove: [],
  addPerkButtonClick: false,
  initialPerkSelection: false,
  showPerkNotification: false,
  shippingAddressContinueClick: false,
};

function CheckoutReducer(state = initialCheckoutState, action) {
  switch (action.type) {
    case 'RESET_EXPRESS_CHECKOUT_REDUCER':
      return { ...initialCheckoutState, stateCache: Date.now() };
    case 'UPDATED_PROCESS_STEP_COMPLETED': {
      return { ...state, updateProcessCompleted: action.value, stateCache: Date.now() };
    }
    case 'DISPLAY_SAVE_CART_SECTION':
      return { ...state, displaySavecartSection: action.value };
    case 'DISPLAY_SAVE_CART_SUCCESS_SECTION':
      return { ...state, saveCartSuccessResponse: action.value };
    case actionTypes.GET_CHECKOUT_DETAILS_SUCCESS:
      return { ...state, status: action.response, isValidPromoResponse: {} };
    case actionTypes.EXPRESS_CHECKOUT_DETAILS_PREFETCH:
      return { ...state, prefetchExpressCheckoutStatus: action.response };
    case actionTypes.GET_CHECKOUT_DETAILS_RESPONSE:
      return {
        ...state,
        status: true,
        isLoaded: true,
        isGetCheckoutApiLoaded: true,
        getCheckoutResponse: action.response,
        featureFlags: action.response?.data?.featureFlags || {},
        cart: action.response?.data?.cart || {},
        orderDetails: action.response?.data?.cart?.orderDetails || {},
        lineDetails: action.response?.data?.cart?.lineDetails || {},
        cartHeader: action.response?.data?.cart?.cartHeader || {},
        depletionType: action.response?.data?.cart?.lineDetails?.lineInfo?.newLine1?.deviceItem?.depletionType || '',
        shipment: action.response?.data?.shipment || {},
        payment: action.response?.data?.payment || {},
        smsEnabledDevice: action.response?.data?.smsEnabledDevice || {},
        validateOrderDetails: action.response?.data?.validateOrderDetails || {},
        isValidPromoResponse: {},
        approvalStatus: action.response?.data?.cart?.orderDetails?.orderList?.[0]?.creditApplication?.creditApprovalStatus,
        stateCache: Date.now(),
        errors: {},
        errorInfo: {
          status: false,
        },
      };

    case actionTypes.EXPRESS_CHECKOUT_API_FAILURE:
      return {
        ...state,
        errors: action.response?.errors,
        isLoaded: true,
        errorInfo: {
          status: true,
        },
      };

    case actionTypes.UPDATE_ABOUT_YOURSELF_FORM:
      return {
        ...state,
        ...(action?.data || {}),
        aboutYourselfAvailable: true,
      };

    case actionTypes.VERIFY_EMAIL_MANUAL:
      return {
        ...state,
        isLoaded: true,
        isManual: action?.data || '',
        response: action.response?.data || {},
      };

    case actionTypes.VALIDATE_MOBILE_NO:
      return {
        ...state,
        phoneAPiResponse: action.response,
      };

    case actionTypes.EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY_SUCCESS:
      return {
        ...state,
        status: true,
        isLoaded: true,
        addRemoveResponse: action.response,
      };
    case actionTypes.EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY_FAILURE:
      return {
        ...state,
        errors: action.response?.errors,
      };

    case actionTypes.EXPRESS_CHECKOUT_ADD_REMOVE_YTTV_SUCCESS:
      return {
        ...state,
        status: true,
        isLoaded: true,
        removeYtTvResponse: action.response,
      };

    case actionTypes.EXPRESS_CHECKOUT_ADD_REMOVE_YTTV_FAILURE:
      return {
        ...state,
        error: action.response?.error,
      };

    case actionTypes.EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE_SUCCESS:
      return {
        ...state,
        status: true,
        isLoaded: true,
        isValidPromoResponse: action.response,
        stateCache: Date.now(),
      };

    case actionTypes.EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE_FAILURE:
      return {
        ...state,
        isValidPromoResponse: action.errors,
        stateCache: Date.now(),
      };

    case actionTypes.EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL_SUCCESS:
      return {
        ...state,
        status: true,
        isLoaded: true,
        accountOwnerEmail: action.response.serviceBody?.serviceResponse?.context?.cartInfo?.saveCartEmailId || '',
        accountOwnerEmailSent:
          (action.response.serviceHeader?.statusCode === '00' && action.response?.serviceHeader?.statusMsg === 'SUCCESS') || false,
        stateCache: Date.now(),
      };

    case actionTypes.EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL_FAILURE:
      return {
        ...state,
        errors: action.errors,
        errorInfo: {
          status: true,
        },
        stateCache: Date.now(),
      };

    case actionTypes.EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL_RESET:
      return { ...state, accountOwnerEmail: '', accountOwnerEmailSent: false };

    // CONTACT_INFO_ERRORS
    case actionTypes.CONTACT_INFO_ERRORS:
      // alert('REDUCER');
      return {
        ...state,
        isFormErrors: action.data,
      };
    case actionTypes.EXPRESS_CHECKOUT_CONTACT_FORM_UNSAVED:
      return {
        ...state,
        isContactFormUnsaved: action.payload,
      };

    case 'UPDATE_NBX_OFFER_RECOMMENDATION_EC':
      return { ...state, fwaOfferECRecommendations: action.response };

    case actionTypes.EC_EMAIL_VALIDATE_API_RESPONSE:
      return { ...state, isEmailSuccess: action.response };

    case 'MAX_ATTEMPTS_EMAIL':
      return { ...state, emailMaxAttempts: action.response };

    case actionTypes.EXPRESS_CHECKOUT_SIDE_DRAWER:
      return { ...state, showPerkDrawer: action.value };

    case actionTypes.EXPRESS_CHECKOUT_SELECTED_PERKS_ADD:
      return { ...state, ecSelectedPerksAdd: action.value, stateCache: Date.now() };

    case actionTypes.EXPRESS_CHECKOUT_SELECTED_PERKS_REMOVE:
      return { ...state, ecSelectedPerksRemove: action.value, stateCache: Date.now() };

    case actionTypes.ADD_PERK_BUTTON_CLICK:
      return { ...state, addPerkButtonClick: action.value };

    case actionTypes.SHOW_PERK_NOTIFICATION:
      return { ...state, showPerkNotification: action.value };

    case actionTypes.INIT_PERK_SELECTION_EXPRESS_CHECKOUT:
      return { ...state, initialPerkSelection: action.value };

    case actionTypes.SHIPPING_ADDRESS_CONTINUE_CLICK:
      return { ...state, shippingAddressContinueClick: action.response };
    default:
      return state;
  }
}

export default CheckoutReducer;
